var React = require('react');

function Star (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_184_3421)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.99982 1.38452L12.334 6.11569C12.6243 6.70522 13.1869 7.1137 13.8377 7.20796L19.0582 7.96657L15.2801 11.6489C14.8088 12.1082 14.5948 12.7681 14.7056 13.4159L15.5973 18.6154L10.9275 16.1601C10.3455 15.8548 9.6512 15.8548 9.06915 16.1601L4.39932 18.6154L5.2911 13.4159C5.40182 12.7681 5.18785 12.1067 4.71653 11.6489L0.938477 7.96657L6.15893 7.20796C6.8098 7.1137 7.3709 6.70522 7.66267 6.11569L9.99683 1.38452H9.99982Z","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_184_3421"},React.createElement("rect",{"width":"20","height":"20","fill":"white"})))]);
}

Star.defaultProps = {"viewBox":"0 0 20 20","fill":"none"};

module.exports = Star;

Star.default = Star;
